module.exports = __webpack_public_path__ + "media/images/icons/twotone/heart-09b203d6caca49039a352a09eb41e12b.svg";